import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { IntegrationService } from 'src/app/services/integration-service';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent implements OnInit {
  platforms: string[];
  platformKeys: any[] = [];

  displayedColumns: string[] = [
    'platform',
    'description',
    'storeIdentifier',
    'accessKey',
    'secretKey',
    'plugin',
    'isVerified',
    'action',
    "action2"
  ];
  keys: any = {
    Shopify: { accessKey: '', secretKey: '' },
    Stripe: { accessKey: '', secretKey: '' },
  };

  editedRow: any = null;

  showPluginPopup = false;

  selectedRow: any = null;

  pluginForm = {
    description: '',
    plugin: ''
  };

  platform: any = "";

  constructor(
    private integrationService: IntegrationService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    forkJoin([this.integrationService.fetchPlatforms(), this.integrationService.fetchKeys()]).subscribe(([platform, key]) => {
      this.platforms = platform.data;
      this.platformKeys = key.data;
      //console.log(this.platformKeys, this.platforms);
    })
  }

  generateKey(platform: string, element: any): void {
    this.editedRow = null;
    if (!element.storeIdentifier) return;
    this.integrationService.generateKey(platform, element.storeIdentifier).subscribe(
      (keyResponse: any) => {
        element.accessKey = keyResponse.data.accessKey;
        element.secretKey = keyResponse.data.secretKey;

        if (element.id || element._id) {
          this.integrationService.updatePlatformDetails(
            platform,
            element.id || element._id,
            {
              description: element.description || '',
              plugin: element.plugin || ''
            }
          ).subscribe();
        }
      }
    );
  }

  addKeys() {
    this.editedRow = null;
    if (!this.platformKeys[this.platformKeys.length - 1] || this.platformKeys[this.platformKeys.length - 1].mapHash || this.platformKeys[this.platformKeys.length - 1].secretKey || this.platformKeys[this.platformKeys.length - 1].accessKey) {
      this.platformKeys = [...this.platformKeys, {
        platform: 'shopify',
        storeIdentifier: '',
        description: '',
        plugin: ''
      }];
    }
  }

  startEdit(row: any) {
    if (row?.isVerified == true) return;
    this.editedRow = row;
  }


  openPluginPopup(platform: any, element: any) {
    this.platform = platform;
    this.selectedRow = element;

    this.pluginForm = {
      description: element.description || '',
      plugin: element.plugin || ''
    };

    this.showPluginPopup = true;
  }

  closePluginPopup() {
    this.showPluginPopup = false;
  }

  savePluginDetails() {
    if (this.selectedRow) {

      this.selectedRow.description = this.pluginForm.description;

      this.selectedRow.plugin = this.pluginForm.plugin;

      let platform: string = this.selectedRow.platform;
      let id: any = this.selectedRow.id || this.selectedRow._id;
      let payload: { description: string; plugin: string } = {
        description: this.selectedRow.description,
        plugin: this.selectedRow.plugin
      }


      this.integrationService
        .updatePlatformDetails(this.platform, id, payload)
        .subscribe({
          next: (res: any) => {

            console.log('Update Success:', res);

            if (this.selectedRow) {

              this.selectedRow.description = payload.description;

              this.selectedRow.plugin = payload.plugin;
            }

            this.closePluginPopup();

          },

          error: (err: any) => {

            console.error('Update Failed:', err);

          }
        });
    }
  }
}